import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_ERROR,
} from '../../actions/shared/index'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../constants/fetchStates'

const profileReducer = (state = { status: IDLE }, { type, payload, error }) => {
  switch (type) {
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        ...payload,
        status: FETCHED
      }
    case FETCH_PROFILE_ERROR:
      return {
        ...state,
        error,
        status: FAILED
      }
    default:
      return state
  }
}

export default profileReducer
